module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Search_Icon_Large.8ae59eef.png";